import React, { useCallback, useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import BiSpan from '@wix/da-bi/pkg/Components/BiSpan';
import { BiData, TopNavMenuClickBiEvent } from '@wix/da-bi/pkg/events';
import { SessionContext } from '@wix/da-react-context/pkg/publicSession';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useAction } from '@wix/da-hooks/pkg/useAction';
import LogoutItem from '../../../_partials/LogoutItem';
import { userLogoutButtonClicked } from '../../../redux/actions';
import { UserMenuContext } from '../UserMenuMobile/UserMenuContext';

export function useLogoutItem() {
  const { t } = useTranslation();
  const isMobile = useContext(MobileContext);
  const { isOpen: isUserMenuOpen } = useContext(UserMenuContext);
  const dispatchLogoutClickAction = useAction(userLogoutButtonClicked);
  const { csrfToken } = useContext(SessionContext);
  const logoutItemRef = useRef<HTMLFormElement>(null);

  const handleClick = useCallback(() => {
    dispatchLogoutClickAction();

    // Avoid a race condition and let sagas do their thing before submitting the form
    setTimeout(() => {
      logoutItemRef && logoutItemRef.current && logoutItemRef.current.submit();
    }, 100);
  }, [dispatchLogoutClickAction]);

  return {
    label: (
      <LogoutItem
        formRef={logoutItemRef}
        token={csrfToken}
        label={
          isMobile ? (
            t('siteHeaderMobile.userMenu.logOut')
          ) : (
            <BiSpan
              biData={BiData<TopNavMenuClickBiEvent>({
                evid: 702,
                link_url: URLS.LOGOUT,
                menu_item: 'logout',
                menu_name: 'profile',
              })}
            >
              {t('siteHeader.userMenu.logOut')}
            </BiSpan>
          )
        }
      />
    ),
    onClick: handleClick,
    tabIndex: isUserMenuOpen || !isMobile ? 0 : -1,
  };
}
